export const idlFactory = ({ IDL }) => {
  const CustomTokenPair = IDL.Record({
    'name' : IDL.Text,
    'network' : IDL.Opt(IDL.Text),
    'symbol' : IDL.Text,
    'contractAddress' : IDL.Opt(IDL.Text),
  });
  const UserRole = IDL.Variant({
    'admin' : IDL.Null,
    'user' : IDL.Null,
    'guest' : IDL.Null,
  });
  const WalletType = IDL.Variant({
    'web3' : IDL.Null,
    'ravencoinCore' : IDL.Null,
    'trustWallet' : IDL.Null,
  });
  const RavencoinOrderType = IDL.Variant({
    'buy' : IDL.Null,
    'sell' : IDL.Null,
  });
  const AdminActivityType = IDL.Variant({
    'registryAudit' : IDL.Null,
    'walletRequirementToggle' : IDL.Null,
    'passcodeUpdate' : IDL.Null,
    'reMapping' : IDL.Null,
    'withdrawal' : IDL.Null,
    'assetSync' : IDL.Null,
    'validationTest' : IDL.Null,
    'feeUpdate' : IDL.Null,
    'temporaryAccessToggle' : IDL.Null,
  });
  const AdminActivity = IDL.Record({
    'activityType' : AdminActivityType,
    'adminPrincipal' : IDL.Principal,
    'timestamp' : IDL.Int,
    'details' : IDL.Text,
  });
  const ApiKeyStatus = IDL.Variant({
    'active' : IDL.Null,
    'revoked' : IDL.Null,
  });
  const ApiKey = IDL.Record({
    'key' : IDL.Text,
    'status' : ApiKeyStatus,
    'name' : IDL.Text,
    'createdAt' : IDL.Int,
    'rateLimitPerMinute' : IDL.Nat,
    'lastUsed' : IDL.Opt(IDL.Int),
    'requestCount' : IDL.Nat,
  });
  const AtomicSwapState = IDL.Variant({
    'participated' : IDL.Null,
    'initiated' : IDL.Null,
    'redeemed' : IDL.Null,
    'refunded' : IDL.Null,
  });
  const HTLC = IDL.Record({
    'redeemedAt' : IDL.Opt(IDL.Int),
    'initiator' : IDL.Principal,
    'createdAt' : IDL.Int,
    'refundedAt' : IDL.Opt(IDL.Int),
    'participant' : IDL.Principal,
    'state' : AtomicSwapState,
    'secretHash' : IDL.Vec(IDL.Nat8),
    'amount' : IDL.Float64,
    'timeLock' : IDL.Int,
  });
  const RavencoinHTLC = IDL.Record({
    'id' : IDL.Nat,
    'redeemedAt' : IDL.Opt(IDL.Int),
    'initiatorTxId' : IDL.Opt(IDL.Text),
    'rvnAmount' : IDL.Float64,
    'initiator' : IDL.Principal,
    'createdAt' : IDL.Int,
    'participantTxId' : IDL.Opt(IDL.Text),
    'assetAmount' : IDL.Float64,
    'initiatorAddress' : IDL.Text,
    'refundedAt' : IDL.Opt(IDL.Int),
    'participant' : IDL.Principal,
    'state' : AtomicSwapState,
    'secretHash' : IDL.Vec(IDL.Nat8),
    'assetName' : IDL.Text,
    'orderId1' : IDL.Nat,
    'orderId2' : IDL.Nat,
    'participantAddress' : IDL.Text,
    'timeLock' : IDL.Int,
  });
  const RavencoinOrderStatus = IDL.Variant({
    'partiallyFilled' : IDL.Null,
    'active' : IDL.Null,
    'cancelled' : IDL.Null,
    'expired' : IDL.Null,
    'completed' : IDL.Null,
    'matched' : IDL.Null,
  });
  const RavencoinConfirmationsConfig = IDL.Record({
    'defaultConfirmations' : IDL.Nat,
    'highValueConfirmations' : IDL.Nat,
    'highValueUsd' : IDL.Float64,
  });
  const RavencoinOrder = IDL.Record({
    'id' : IDL.Nat,
    'filledAmount' : IDL.Float64,
    'status' : RavencoinOrderStatus,
    'creator' : IDL.Principal,
    'expiresAt' : IDL.Int,
    'rvnAmount' : IDL.Float64,
    'createdAt' : IDL.Int,
    'walletAddress' : IDL.Text,
    'assetAmount' : IDL.Float64,
    'orderType' : RavencoinOrderType,
    'matchedWith' : IDL.Opt(IDL.Nat),
    'secretHash' : IDL.Opt(IDL.Vec(IDL.Nat8)),
    'htlcId' : IDL.Opt(IDL.Nat),
    'assetName' : IDL.Text,
    'price' : IDL.Float64,
  });
  const SwapOffer = IDL.Record({
    'id' : IDL.Nat,
    'status' : IDL.Variant({
      'active' : IDL.Null,
      'cancelled' : IDL.Null,
      'expired' : IDL.Null,
      'completed' : IDL.Null,
    }),
    'creator' : IDL.Principal,
    'fromAmount' : IDL.Float64,
    'createdAt' : IDL.Int,
    'rate' : IDL.Float64,
    'expiration' : IDL.Int,
    'fromToken' : IDL.Text,
    'toToken' : IDL.Text,
    'toAmount' : IDL.Float64,
  });
  const TransactionStatus = IDL.Variant({
    'pending' : IDL.Null,
    'confirmed' : IDL.Null,
    'failed' : IDL.Null,
  });
  const Transaction = IDL.Record({
    'id' : IDL.Text,
    'status' : TransactionStatus,
    'routedVia' : IDL.Opt(IDL.Text),
    'timestamp' : IDL.Int,
    'wallet' : IDL.Principal,
    'fromToken' : IDL.Text,
    'amount' : IDL.Float64,
    'toToken' : IDL.Text,
  });
  const ValidationResult = IDL.Record({
    'message' : IDL.Text,
    'timestamp' : IDL.Int,
    'details' : IDL.Opt(IDL.Text),
    'success' : IDL.Bool,
  });
  const ValidationCategory = IDL.Variant({
    'icApiVerification' : IDL.Null,
    'registryAudit' : IDL.Null,
    'domainSslVerification' : IDL.Null,
    'liveNetworkReVerification' : IDL.Null,
    'atomicSwapEngine' : IDL.Null,
    'tokenVerification' : IDL.Null,
    'walletConnectivity' : IDL.Null,
    'swapSimulation' : IDL.Null,
    'cspSecurityAudit' : IDL.Null,
    'adminFunctions' : IDL.Null,
  });
  const ValidationReport = IDL.Record({
    'result' : ValidationResult,
    'category' : ValidationCategory,
    'lastSuccessfulTest' : IDL.Opt(IDL.Int),
    'errorLog' : IDL.Vec(IDL.Text),
  });
  const AnalyticsData = IDL.Record({
    'onChainVolume' : IDL.Float64,
    'totalSwapCount' : IDL.Nat,
    'thirdPartyVolume' : IDL.Float64,
    'weeklyTrades' : IDL.Vec(IDL.Tuple(IDL.Int, IDL.Nat, IDL.Float64)),
  });
  const UserProfile = IDL.Record({ 'name' : IDL.Text });
  const EscrowDepositInstructions = IDL.Record({
    'feeAmount' : IDL.Float64,
    'assetAmount' : IDL.Float64,
    'instructions' : IDL.Text,
    'orderId' : IDL.Nat,
    'totalRvnFee' : IDL.Float64,
    'assetName' : IDL.Text,
    'platformAddress' : IDL.Text,
  });
  const FeeConfig = IDL.Record({
    'dexFlatFee' : IDL.Float64,
    'liquidityProviderReward' : IDL.Float64,
  });
  const OnChainAuditEntry = IDL.Record({
    'activityType' : IDL.Text,
    'timestamp' : IDL.Int,
    'details' : IDL.Text,
    'outcome' : IDL.Text,
    'transactionId' : IDL.Text,
  });
  const DailyVisit = IDL.Record({
    'date' : IDL.Int,
    'uniqueVisitors' : IDL.Nat,
    'totalVisits' : IDL.Nat,
  });
  const VisitorStats = IDL.Record({
    'totalUniqueVisitors' : IDL.Nat,
    'dailyVisits' : IDL.Vec(DailyVisit),
    'todayVisits' : IDL.Nat,
    'todayUniqueVisitors' : IDL.Nat,
    'weeklyVisits' : IDL.Nat,
    'weeklyUniqueVisitors' : IDL.Nat,
    'monthlyVisits' : IDL.Nat,
    'monthlyUniqueVisitors' : IDL.Nat,
    'yearlyVisits' : IDL.Nat,
    'yearlyUniqueVisitors' : IDL.Nat,
  });
  const RavencoinAsset = IDL.Record({
    'creator' : IDL.Text,
    'metadata' : IDL.Opt(IDL.Text),
    'quantity' : IDL.Float64,
    'assetName' : IDL.Text,
    'isNFT' : IDL.Bool,
  });
  const RavencoinNFT = IDL.Record({
    'creator' : IDL.Text,
    'description' : IDL.Opt(IDL.Text),
    'imageUrl' : IDL.Opt(IDL.Text),
    'assetName' : IDL.Text,
  });
  const OrderDepth = IDL.Record({
    'totalRvnAmount' : IDL.Float64,
    'orderCount' : IDL.Nat,
    'totalAssetAmount' : IDL.Float64,
    'price' : IDL.Float64,
  });
  const Result = IDL.Variant({ 'ok' : IDL.Text, 'err' : IDL.Text });
  const HeaderField = IDL.Record({ 'value' : IDL.Text, 'name' : IDL.Text });
  const HttpResponsePayload = IDL.Record({
    'status' : IDL.Nat,
    'body' : IDL.Vec(IDL.Nat8),
    'headers' : IDL.Vec(HeaderField),
  });
  const TransformationInput = IDL.Record({
    'context' : IDL.Vec(IDL.Nat8),
    'response' : HttpResponsePayload,
  });
  const TransformationOutput = IDL.Record({
    'status' : IDL.Nat,
    'body' : IDL.Vec(IDL.Nat8),
    'headers' : IDL.Vec(HeaderField),
  });
  return IDL.Service({
    'acceptSwapOffer' : IDL.Func([IDL.Nat], [], []),
    'addCustomTokenPair' : IDL.Func([CustomTokenPair], [], []),
    'assignCallerUserRole' : IDL.Func([IDL.Principal, UserRole], [], []),
    'calculateRavencoinFee' : IDL.Func([IDL.Float64], [IDL.Float64], ['query']),
    'refreshRavencoinPriceUsd' : IDL.Func([], [IDL.Opt(IDL.Float64)], []),
    'getRavencoinConfirmationsConfig' : IDL.Func(
        [],
        [RavencoinConfirmationsConfig],
        ['query'],
      ),
    'updateRavencoinConfirmationsConfig' : IDL.Func(
        [RavencoinConfirmationsConfig],
        [],
        [],
      ),
    'getRavencoinTxConfirmations' : IDL.Func([IDL.Text], [IDL.Nat], []),
    'getRavencoinHTLCRequiredConfirmations' : IDL.Func([IDL.Nat], [IDL.Nat], ['query']),
    'calculateSwapFees' : IDL.Func(
        [IDL.Float64],
        [
          IDL.Record({
            'finalAmount' : IDL.Float64,
            'totalFees' : IDL.Float64,
            'dexFee' : IDL.Float64,
            'liquidityProviderReward' : IDL.Float64,
          }),
        ],
        ['query'],
      ),
    'cancelRavencoinOrder' : IDL.Func([IDL.Nat], [], []),
    'cancelRavencoinOrderManual' : IDL.Func([IDL.Nat, IDL.Text], [], []),
    'cancelSwapOffer' : IDL.Func([IDL.Nat], [], []),
    'checkRavencoinNodeStatus' : IDL.Func([], [IDL.Text], []),
    'clearTemporaryAdminSession' : IDL.Func([], [], []),
    'completeSwapOffer' : IDL.Func([IDL.Nat], [], []),
    'configureRavencoinRPC' : IDL.Func(
        [IDL.Text, IDL.Opt(IDL.Text)],
        [IDL.Text],
        [],
      ),
    'connectWallet' : IDL.Func([WalletType, IDL.Text], [], []),
    'createApiKey' : IDL.Func([IDL.Text, IDL.Nat], [IDL.Text], []),
    'createRavencoinOrder' : IDL.Func(
        [
          RavencoinOrderType,
          IDL.Text,
          IDL.Float64,
          IDL.Float64,
          IDL.Text,
          IDL.Nat,
          IDL.Opt(IDL.Vec(IDL.Nat8)),
        ],
        [IDL.Nat],
        [],
      ),
    'createRavencoinOrderManual' : IDL.Func(
        [
          RavencoinOrderType,
          IDL.Text,
          IDL.Float64,
          IDL.Float64,
          IDL.Text,
          IDL.Nat,
          IDL.Opt(IDL.Vec(IDL.Nat8)),
          IDL.Text,
        ],
        [IDL.Nat],
        [],
      ),
    'createSwapOffer' : IDL.Func(
        [IDL.Text, IDL.Text, IDL.Float64, IDL.Float64, IDL.Int],
        [IDL.Nat],
        [],
      ),
    'disconnectWallet' : IDL.Func([], [], []),
    'executeSwap' : IDL.Func(
        [IDL.Text, IDL.Text, IDL.Float64, IDL.Opt(IDL.Text)],
        [IDL.Text],
        [],
      ),
    'expireOutdatedOffers' : IDL.Func([], [], []),
    'fetchExchangeRates' : IDL.Func([], [IDL.Text], ['query']),
    'fetchExchangeRatesLive' : IDL.Func([], [IDL.Text], []),
    'getAdminActivityLog' : IDL.Func([], [IDL.Vec(AdminActivity)], ['query']),
    'getAdminWalletAddress' : IDL.Func([], [IDL.Text], ['query']),
    'getAllApiKeys' : IDL.Func(
        [],
        [IDL.Vec(IDL.Tuple(IDL.Text, ApiKey))],
        ['query'],
      ),
    'getAllAtomicSwaps' : IDL.Func(
        [],
        [IDL.Vec(IDL.Tuple(IDL.Nat, HTLC))],
        ['query'],
      ),
    'getAllConnectedWallets' : IDL.Func(
        [],
        [IDL.Vec(IDL.Tuple(IDL.Principal, WalletType))],
        ['query'],
      ),
    'getAllRavencoinHTLCs' : IDL.Func([], [IDL.Vec(RavencoinHTLC)], ['query']),
    'getAllRavencoinOrders' : IDL.Func(
        [],
        [IDL.Vec(RavencoinOrder)],
        ['query'],
      ),
    'getAllSwapOffers' : IDL.Func(
        [],
        [IDL.Vec(IDL.Tuple(IDL.Nat, SwapOffer))],
        ['query'],
      ),
    'getAllTransactions' : IDL.Func(
        [],
        [IDL.Vec(IDL.Tuple(IDL.Principal, IDL.Vec(Transaction)))],
        ['query'],
      ),
    'getAllValidationHistory' : IDL.Func(
        [],
        [IDL.Vec(IDL.Tuple(IDL.Nat, IDL.Vec(ValidationResult)))],
        ['query'],
      ),
    'getAllValidationReports' : IDL.Func(
        [],
        [IDL.Vec(IDL.Tuple(IDL.Nat, ValidationReport))],
        ['query'],
      ),
    'getAnalytics' : IDL.Func([], [AnalyticsData], ['query']),
    'getAssetLeaderboard' : IDL.Func(
        [IDL.Opt(IDL.Text), IDL.Opt(IDL.Nat)],
        [
          IDL.Record({
            'totalAssets' : IDL.Nat,
            'topAssets' : IDL.Vec(
              IDL.Record({
                'liquidity' : IDL.Float64,
                'volume24h' : IDL.Float64,
                'swaps24h' : IDL.Nat,
                'assetName' : IDL.Text,
              })
            ),
            'timestamp' : IDL.Int,
          }),
        ],
        ['query'],
      ),
    'getAssetStats' : IDL.Func(
        [IDL.Opt(IDL.Text)],
        [
          IDL.Record({
            'totalAssets' : IDL.Nat,
            'totalVolume' : IDL.Float64,
            'timestamp' : IDL.Int,
            'activeAssets' : IDL.Nat,
          }),
        ],
        ['query'],
      ),
    'getAssetSyncStatus' : IDL.Func(
        [],
        [
          IDL.Record({
            'syncInProgress' : IDL.Bool,
            'retryCount' : IDL.Nat,
            'lastSyncTimestamp' : IDL.Int,
            'assetCount' : IDL.Nat,
          }),
        ],
        ['query'],
      ),
    'getAssetsWithActiveOrders' : IDL.Func([], [IDL.Vec(IDL.Text)], ['query']),
    'getAtomicSwap' : IDL.Func([IDL.Nat], [IDL.Opt(HTLC)], ['query']),
    'getAvailableSwapOffers' : IDL.Func([], [IDL.Vec(SwapOffer)], ['query']),
    'getCallerUserProfile' : IDL.Func([], [IDL.Opt(UserProfile)], ['query']),
    'getCallerUserRole' : IDL.Func([], [UserRole], ['query']),
    'getConnectedWalletAddress' : IDL.Func([], [IDL.Opt(IDL.Text)], ['query']),
    'getConnectedWalletType' : IDL.Func([], [IDL.Opt(WalletType)], ['query']),
    'getCustomTokenPairs' : IDL.Func([], [IDL.Vec(CustomTokenPair)], ['query']),
    'getEscrowDepositInstructions' : IDL.Func(
        [IDL.Nat],
        [IDL.Opt(EscrowDepositInstructions)],
        ['query'],
      ),
    'getEscrowDepositStatus' : IDL.Func(
        [IDL.Nat],
        [
          IDL.Opt(
            IDL.Record({
              'verified' : IDL.Bool,
              'refunded' : IDL.Bool,
              'feeTxId' : IDL.Opt(IDL.Text),
              'assetTxId' : IDL.Opt(IDL.Text),
            })
          ),
        ],
        ['query'],
      ),
    'getFeeBalance' : IDL.Func([], [IDL.Float64], ['query']),
    'getFeeConfig' : IDL.Func([], [FeeConfig], ['query']),
    'getMyAtomicSwaps' : IDL.Func([], [IDL.Vec(HTLC)], ['query']),
    'getMyRavencoinHTLCs' : IDL.Func([], [IDL.Vec(RavencoinHTLC)], ['query']),
    'getMyRavencoinOrders' : IDL.Func([], [IDL.Vec(RavencoinOrder)], ['query']),
    'getRavencoinHTLCsByWalletAddress' : IDL.Func(
        [IDL.Text],
        [IDL.Vec(RavencoinHTLC)],
        ['query'],
      ),
    'getRavencoinOrdersByWalletAddress' : IDL.Func(
        [IDL.Text],
        [IDL.Vec(RavencoinOrder)],
        ['query'],
      ),
    'getMySwapOffers' : IDL.Func([], [IDL.Vec(SwapOffer)], ['query']),
    'getOnChainAuditFeed' : IDL.Func(
        [],
        [IDL.Vec(OnChainAuditEntry)],
        ['query'],
      ),
    'getPlatformRavencoinAddress' : IDL.Func([], [IDL.Text], ['query']),
    'getPublicAnalytics' : IDL.Func(
        [],
        [IDL.Record({ 'totalSwapCount' : IDL.Nat })],
        ['query'],
      ),
    'getVisitorStats' : IDL.Func([], [VisitorStats], ['query']),
    'getRavencoinAssetLeaderboard' : IDL.Func(
        [],
        [IDL.Vec(RavencoinAsset)],
        ['query'],
      ),
    'getRavencoinAssets' : IDL.Func(
        [IDL.Text],
        [IDL.Vec(RavencoinAsset)],
        ['query'],
      ),
    'getRavencoinAssetsPaginated' : IDL.Func(
        [IDL.Nat, IDL.Nat],
        [
          IDL.Record({
            'assets' : IDL.Vec(RavencoinAsset),
            'totalCount' : IDL.Nat,
            'currentPage' : IDL.Nat,
            'totalPages' : IDL.Nat,
          }),
        ],
        ['query'],
      ),
    'getRavencoinHTLC' : IDL.Func(
        [IDL.Nat],
        [IDL.Opt(RavencoinHTLC)],
        ['query'],
      ),
    'getRavencoinNFTs' : IDL.Func(
        [IDL.Text],
        [IDL.Vec(RavencoinNFT)],
        ['query'],
      ),
    'getRavencoinOrder' : IDL.Func(
        [IDL.Nat],
        [IDL.Opt(RavencoinOrder)],
        ['query'],
      ),
    'getRavencoinOrderBook' : IDL.Func(
        [IDL.Opt(IDL.Text)],
        [IDL.Vec(IDL.Tuple(IDL.Nat, RavencoinOrder))],
        ['query'],
      ),
    'getRavencoinOrderDepth' : IDL.Func(
        [IDL.Text, IDL.Nat],
        [
          IDL.Record({
            'sellDepth' : IDL.Vec(OrderDepth),
            'buyDepth' : IDL.Vec(OrderDepth),
          }),
        ],
        ['query'],
      ),
    'getRavencoinRPCConfig' : IDL.Func(
        [],
        [IDL.Record({ 'url' : IDL.Text, 'hasAuth' : IDL.Bool })],
        ['query'],
      ),
    'getRavencoinWalletAssets' : IDL.Func(
        [IDL.Text, IDL.Bool],
        [IDL.Vec(RavencoinAsset)],
        [],
      ),
    'getRavencoinWalletNFTs' : IDL.Func(
        [IDL.Text],
        [IDL.Vec(RavencoinNFT)],
        [],
      ),
    'getSupportedTokens' : IDL.Func(
        [],
        [IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text))],
        ['query'],
      ),
    'getSwapMetrics' : IDL.Func(
        [IDL.Opt(IDL.Text)],
        [
          IDL.Record({
            'totalVolume' : IDL.Float64,
            'onChainVolume' : IDL.Float64,
            'totalSwaps' : IDL.Nat,
            'thirdPartyVolume' : IDL.Float64,
            'timestamp' : IDL.Int,
            'weeklyTrades' : IDL.Vec(IDL.Tuple(IDL.Int, IDL.Nat, IDL.Float64)),
          }),
        ],
        ['query'],
      ),
    'getSwapOffer' : IDL.Func([IDL.Nat], [IDL.Opt(SwapOffer)], ['query']),
    'getSwapQuote' : IDL.Func(
        [IDL.Text, IDL.Text, IDL.Float64],
        [
          IDL.Record({
            'fees' : IDL.Record({
              'totalFees' : IDL.Float64,
              'dexFee' : IDL.Float64,
              'liquidityProviderReward' : IDL.Float64,
            }),
            'priceImpact' : IDL.Float64,
            'exchangeRate' : IDL.Float64,
            'inputAmount' : IDL.Float64,
            'outputAmount' : IDL.Float64,
          }),
        ],
        [],
      ),
    'getTemporaryAccessStatus' : IDL.Func([], [IDL.Bool], ['query']),
    'getTemporaryAdminSessionStatus' : IDL.Func(
        [],
        [
          IDL.Opt(
            IDL.Record({
              'expiresAt' : IDL.Int,
              'isActive' : IDL.Bool,
              'remainingMinutes' : IDL.Nat,
            })
          ),
        ],
        ['query'],
      ),
    'getTokenStats' : IDL.Func(
        [IDL.Opt(IDL.Text)],
        [
          IDL.Record({
            'totalVolume' : IDL.Float64,
            'totalTokens' : IDL.Nat,
            'topTokens' : IDL.Vec(
              IDL.Record({
                'volume' : IDL.Float64,
                'swaps' : IDL.Nat,
                'symbol' : IDL.Text,
              })
            ),
            'timestamp' : IDL.Int,
          }),
        ],
        ['query'],
      ),
    'getTransactionHistory' : IDL.Func([], [IDL.Vec(Transaction)], ['query']),
    'getUserProfile' : IDL.Func(
        [IDL.Principal],
        [IDL.Opt(UserProfile)],
        ['query'],
      ),
    'getValidationHistory' : IDL.Func(
        [ValidationCategory],
        [IDL.Vec(ValidationResult)],
        ['query'],
      ),
    'getValidationReport' : IDL.Func(
        [ValidationCategory],
        [IDL.Opt(ValidationReport)],
        ['query'],
      ),
    'getWalletRequirementStatus' : IDL.Func([], [IDL.Bool], ['query']),
    'initializeAccessControl' : IDL.Func([], [], []),
    'initiateSwap' : IDL.Func(
        [IDL.Principal, IDL.Float64, IDL.Vec(IDL.Nat8), IDL.Int],
        [IDL.Nat],
        [],
      ),
    'isAdminWalletAddress' : IDL.Func([IDL.Text], [IDL.Bool], ['query']),
    'isCallerAdmin' : IDL.Func([], [IDL.Bool], ['query']),
    'isCallerTemporaryAdmin' : IDL.Func([], [IDL.Bool], ['query']),
    'participateRavencoinHTLC' : IDL.Func([IDL.Nat, IDL.Text], [], []),
    'participateRavencoinHTLCManual' : IDL.Func(
        [IDL.Nat, IDL.Text, IDL.Text],
        [],
        [],
      ),
    'participateSwap' : IDL.Func(
        [IDL.Nat, IDL.Float64, IDL.Vec(IDL.Nat8), IDL.Int],
        [],
        [],
      ),
    'performICAPIVerification' : IDL.Func(
        [],
        [
          IDL.Record({
            'dnsPropagation' : IDL.Record({
              'cloudflare' : ValidationResult,
              'openDns' : ValidationResult,
              'google' : ValidationResult,
            }),
            'registryLookup' : ValidationResult,
            'canisterEndpoints' : IDL.Record({
              'ic0App' : ValidationResult,
              'customDomain' : ValidationResult,
            }),
            'registryMapping' : ValidationResult,
            'edgeCache' : ValidationResult,
            'sslCertificate' : ValidationResult,
            'overallHealth' : ValidationResult,
          }),
        ],
        [],
      ),
    'performLiveNetworkReVerification' : IDL.Func(
        [],
        [
          IDL.Record({
            'canisterStatus' : IDL.Record({
              'ic0App' : ValidationResult,
              'customDomain' : ValidationResult,
            }),
            'sslStatus' : ValidationResult,
            'registryStatus' : ValidationResult,
            'overallStatus' : ValidationResult,
            'dnsStatus' : IDL.Record({
              'cloudflare' : ValidationResult,
              'openDns' : ValidationResult,
              'google' : ValidationResult,
            }),
          }),
        ],
        [],
      ),
    'performRegistryAudit' : IDL.Func([], [IDL.Text], []),
    'proxy1inchQuote' : IDL.Func(
        [IDL.Nat, IDL.Text, IDL.Text, IDL.Text],
        [Result],
        [],
      ),
    'proxy1inchSwap' : IDL.Func(
        [
          IDL.Nat,
          IDL.Text,
          IDL.Text,
          IDL.Text,
          IDL.Text,
          IDL.Text,
          IDL.Text,
          IDL.Text,
        ],
        [Result],
        [],
      ),
    'proxyChangeNOWCreate' : IDL.Func(
        [IDL.Text, IDL.Text, IDL.Text, IDL.Text, IDL.Text],
        [Result],
        [],
      ),
    'proxyChangeNOWQuote' : IDL.Func(
        [IDL.Text, IDL.Text, IDL.Text, IDL.Text],
        [Result],
        [],
      ),
    'proxyMM2RPC' : IDL.Func([IDL.Text, IDL.Text], [Result], []),
    'proxySimpleSwapCreate' : IDL.Func(
        [IDL.Text, IDL.Text, IDL.Text, IDL.Text, IDL.Text, IDL.Text],
        [Result],
        [],
      ),
    'proxySimpleSwapQuote' : IDL.Func(
        [IDL.Text, IDL.Text, IDL.Text, IDL.Text],
        [Result],
        [],
      ),
    'proxyStealthEXCreate' : IDL.Func(
        [IDL.Text, IDL.Text, IDL.Text, IDL.Text, IDL.Text],
        [Result],
        [],
      ),
    'proxyStealthEXQuote' : IDL.Func(
        [IDL.Text, IDL.Text, IDL.Text, IDL.Text, IDL.Text],
        [Result],
        [],
      ),
    'redeemRavencoinHTLC' : IDL.Func(
        [IDL.Nat, IDL.Vec(IDL.Nat8), IDL.Text],
        [],
        [],
      ),
    'redeemRavencoinHTLCManual' : IDL.Func(
        [IDL.Nat, IDL.Vec(IDL.Nat8), IDL.Text, IDL.Text],
        [],
        [],
      ),
    'redeemSwap' : IDL.Func([IDL.Nat, IDL.Vec(IDL.Nat8)], [], []),
    'refundRavencoinHTLC' : IDL.Func([IDL.Nat], [], []),
    'refundRavencoinHTLCManual' : IDL.Func([IDL.Nat, IDL.Text], [], []),
    'refundSwap' : IDL.Func([IDL.Nat], [], []),
    'requestRavencoinEscrowRefund' : IDL.Func([IDL.Nat, IDL.Text], [IDL.Text], []),
    'registerAdminWallet' : IDL.Func([IDL.Text, IDL.Text], [], []),
    'removeCustomTokenPair' : IDL.Func([IDL.Text], [], []),
    'revokeApiKey' : IDL.Func([IDL.Text], [], []),
    'runValidationTest' : IDL.Func(
        [ValidationCategory],
        [ValidationResult],
        [],
      ),
    'saveCallerUserProfile' : IDL.Func([UserProfile], [], []),
    'searchRavencoinAssets' : IDL.Func(
        [IDL.Text],
        [IDL.Vec(RavencoinAsset)],
        ['query'],
      ),
    'submitRavencoinEscrowDeposit' : IDL.Func(
        [IDL.Nat, IDL.Text, IDL.Text],
        [],
        [],
      ),
    'submitRavencoinEscrowDepositManual' : IDL.Func(
        [IDL.Nat, IDL.Text, IDL.Text, IDL.Text],
        [],
        [],
      ),
    'submitRavencoinHTLCTxId' : IDL.Func([IDL.Nat, IDL.Text, IDL.Bool], [], []),
    'submitRavencoinHTLCTxIdManual' : IDL.Func(
        [IDL.Nat, IDL.Text, IDL.Bool, IDL.Text],
        [],
        [],
      ),
    'syncRavencoinAssets' : IDL.Func([], [IDL.Text], []),
    'syncWalletWithBackend' : IDL.Func([], [IDL.Bool], []),
    'testEthereumRPC' : IDL.Func([IDL.Text], [IDL.Text], []),
    'trackVisitor' : IDL.Func([], [], []),
    'toggleTemporaryAccess' : IDL.Func([IDL.Bool], [], []),
    'toggleWalletRequirement' : IDL.Func([IDL.Bool], [], []),
    'transform' : IDL.Func(
        [TransformationInput],
        [TransformationOutput],
        ['query'],
      ),
    'updateAdminPasscode' : IDL.Func([IDL.Text], [], []),
    'updateFeeConfig' : IDL.Func([FeeConfig], [], []),
    'updateWeeklyTradeSummary' : IDL.Func(
        [IDL.Int, IDL.Nat, IDL.Float64],
        [],
        [],
      ),
    'uploadAssetBatch' : IDL.Func([IDL.Vec(RavencoinAsset)], [IDL.Text], []),
    'validateAdminPasscode' : IDL.Func([IDL.Text], [IDL.Bool], []),
    'withdrawFees' : IDL.Func([], [IDL.Text], []),
  });
};
export const init = ({ IDL }) => { return []; };
